import { render, staticRenderFns } from "./step-2.vue?vue&type=template&id=45219efd&scoped=true"
import script from "./step-2.vue?vue&type=script&lang=js"
export * from "./step-2.vue?vue&type=script&lang=js"
import style0 from "./step-2.vue?vue&type=style&index=0&id=45219efd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45219efd",
  null
  
)

export default component.exports